var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0031 42.5V18.57C24.0031 17.9034 24.1346 17.2433 24.39 16.6275C24.6454 16.0117 25.0198 15.4524 25.4916 14.9814C25.9635 14.5105 26.5236 14.1373 27.1398 13.8831C27.7561 13.6289 28.4165 13.4987 29.0831 13.5C31.5731 13.5 33.1331 14.24 34.2031 15.62M19.7031 23.29H29.8531",
    stroke: "#FAFAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47656 5.5C6.94613 5.5 6.43742 5.71071 6.06235 6.08579C5.68728 6.46086 5.47656 6.96957 5.47656 7.5V40.5C5.47656 41.0304 5.68728 41.5391 6.06235 41.9142C6.43742 42.2893 6.94613 42.5 7.47656 42.5H40.5166C41.047 42.5 41.5557 42.2893 41.9308 41.9142C42.3058 41.5391 42.5166 41.0304 42.5166 40.5V7.5C42.5166 6.96957 42.3058 6.46086 41.9308 6.08579C41.5557 5.71071 41.047 5.5 40.5166 5.5H7.47656Z",
    stroke: "#FAFAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.f849740fe1e18ac817bbcee35b777212.svg";
export { ForwardRef as ReactComponent };